import { HttpClient } from '../../protocols/http/httpClient'
import { validateHttpStatus } from '../../../validation/validateHttpResponse'
import { IGetPersons, Persons } from '../../../domain/usecases/Persons'
import { Person } from '../../../domain/models/PersonsModel'
import { convertCPForCNPJStringToNumbers } from '../../../utils/convertCPFStringToNumbers'

export class RemoteGetPersons implements IGetPersons {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}
  @validateHttpStatus
  async getAll(params: Persons.GetParams): Promise<Person[]> {
    const persons: Person[] = []

    for (const cpfOrCpnj of params.cpfOrCnpj) {
      try {
        let person
        if (this.isCnpj(cpfOrCpnj)) {
          person = await this.getJuridical({ cnpj: cpfOrCpnj })
        } else {
          person = await this.getIndividual({ cpf: cpfOrCpnj })
        }

        // Only push if we got a valid person object
        if (person && typeof person === 'object') {
          persons.push(person)
        } else {
          console.warn(
            `[RemoteGetPersons] Invalid response for ${cpfOrCpnj}:`,
            person
          )
        }
      } catch (error) {
        console.error(
          `[RemoteGetPersons] Error fetching person ${cpfOrCpnj}:`,
          error
        )
        // Continue to next person instead of breaking the whole loop
      }
    }
    return persons
  }

  @validateHttpStatus
  async getJuridical(params: Persons.GetJuridical): Promise<any> {
    const cnpj = convertCPForCNPJStringToNumbers(params.cnpj)

    return this.httpClient.get?.({
      url: `${this.url}/persons/get-juridic/${cnpj}`
    })
  }

  @validateHttpStatus
  async getIndividual(params: Persons.GetIndividual): Promise<any> {
    const cpf = convertCPForCNPJStringToNumbers(params.cpf)

    return this.httpClient.get?.({
      url: `${this.url}/persons/get-individual/${cpf}`
    })
  }

  private isCnpj(value: string) {
    return value.replace(/\D/g, '').length === 14
  }
}
